import React, { useContext, useState, useEffect } from "react"
import { Link } from "gatsby"
import { StateContext, ShoppingContext } from "../../../StateProvider"
import Image from "../../image"
import CardModal from "../../CardModal/CardModal"

import Helmet from "react-helmet"

// Styles
import "./Card.scss"

// IMG
import infoIcon from "../../../images/card_icons/card-icon.svg"

const Card = ({ title, image, id, currentState, css, notify }) => {
  const [state, setState] = useContext(StateContext)
  const [shopping, setShopping] = useContext(ShoppingContext)
  const choosenAttractions = state && state.filter(item => item.state)
  const [openModal, setOpenModal] = useState(false)

  const handleClick = () => {
    let newArray = [...state]
    newArray[id] = { ...newArray[id], state: !newArray[id].state }
    setState([...newArray])

    if (newArray[id].state === true) {
      notify()
    }
  }

  useEffect(() => {
    let newObject = { ...shopping }
    newObject = {
      ...newObject,
      chosenAttractions: choosenAttractions,
    }
    setShopping({ ...newObject })
  }, [state])

  const imgName = image.split("/")[3].split(".")[0]

  const modalHandeler = () => {
    setOpenModal(!openModal)
  }

  return (
    <>
      {openModal ? (
        <Helmet
          bodyAttributes={{
            class: "overflow-body",
          }}
        />
      ) : null}
      <div className={`card-wrapper card-${css}`}>
        <div className="open-card-id" onClick={modalHandeler}>
          <div className="img-wrapper">
            <Image imgName={imgName} />
          </div>
          <div className="more-infos">
            <p>mehr Infos</p>
            <img src={infoIcon} alt="Info Icon" />
          </div>
          <h3>{title}</h3>
        </div>
        <button
          onClick={handleClick}
          className="main-btn"
          style={currentState ? { background: " #d8405c" } : null}
        >
          {currentState ? "Ausgewählt" : "Auswählen"}
        </button>
      </div>
      {openModal ? <CardModal id={id} close={modalHandeler} /> : null}
    </>
  )
}

export default Card
